//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Code from './code.vue';

// 后端接口入参/出参字段名集中配置（对齐 AccountServer/AccountLogin proto）
const API_FIELDS = {
  // GetAccountEmail
  reqAccountForEmail: 'account',
  respEmail: 'masked_email',
  // SendResetPasswordEmailCode
  reqAccountForSend: 'account',
  // ResetPasswordByEmail
  reqAccount: 'account',
  reqCode: 'email_code',
  reqNewPassword: 'new_password',
  reqNewPasswordConfirm: 'new_password_confirm',
};

// 对邮箱进行脱敏：用户名与域名各保留前后各 1 字符，中间用 * 填充
// 长度 <= 2 的段不做脱敏（信息量本来就极少）；域名带多个 . 时仅处理整体前后
function maskEmail(email) {
  if (!email || typeof email !== 'string') return '';
  const atIdx = email.indexOf('@');
  if (atIdx < 0) return email;
  const user = email.slice(0, atIdx);
  const domain = email.slice(atIdx + 1);
  const maskPart = (s) => {
    if (!s) return s;
    if (s.length <= 2) return s;
    return `${s[0]}${'*'.repeat(s.length - 2)}${s.slice(-1)}`;
  };
  return `${maskPart(user)}@${maskPart(domain)}`;
}

// 密码校验：8-30 字符，同时包含数字、字母、符号
const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).{8,30}$/;
const RESEND_COUNTDOWN = 60;

export default {
  name: 'ForgetPassword',
  components: { Code },
  props: {
    account: {
      type: String,
      required: true,
    },
  },
  data() {
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.form.new_password) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!PASSWORD_REGEX.test(value)) {
        callback(new Error('8-30字符，同时包含数字、字母、符号'));
      } else {
        callback();
      }
    };
    return {
      step: 'confirm-email',
      maskedEmail: '',
      // 标记邮箱拉取是否已完成（无论成功失败），用于区分「加载中」与「无邮箱」文案
      emailLoaded: false,
      form: {
        new_password: '',
        new_password_confirm: '',
        code: '',
      },
      rules: {
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' },
        ],
        new_password_confirm: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirm, trigger: 'blur' },
        ],
      },
      loading: false,
      timeLimit: 0,
      timer: null,
    };
  },
  computed: {
    canSubmit() {
      const { new_password, new_password_confirm, code } = this.form;
      return (
        PASSWORD_REGEX.test(new_password) &&
        new_password === new_password_confirm &&
        code.length === 6
      );
    },
  },
  mounted() {
    this.fetchEmail();
  },
  beforeDestroy() {
    this.clearCountdown();
  },
  methods: {
    // 拉取账号关联邮箱
    fetchEmail() {
      this.$request({
        url: this.$api.forgetGetEmail,
        type: 'post',
        data: {
          [API_FIELDS.reqAccountForEmail]: this.account,
        },
        config: { skipAuthRedirect: true },
        cb: (resp) => {
          const rawEmail = resp?.[API_FIELDS.respEmail] || '';
          // 前端兜底脱敏：如果后端返回的已是脱敏格式（含 *），再次脱敏结果等同无变化
          this.maskedEmail = rawEmail ? maskEmail(rawEmail) : '';
          this.emailLoaded = true;
          // 若走到这里仍然为空，交由视图层展示「该账号未绑定邮箱，请联系管理员找回密码」
          // 后端业务错误（如 12072 未绑定邮箱）由 axios 拦截器统一 toast，此处不再重复提示
        },
        fault: () => {
          this.emailLoaded = true;
          this.maskedEmail = '';
        },
      });
    },
    // 发送验证码（首次从第一步进入第二步，或第二步点击「重新发送」）
    handleSendCode() {
      if (!this.maskedEmail) return;
      if (this.timer !== null) return;
      this.loading = true;
      this.$request({
        url: this.$api.forgetSendCode,
        type: 'post',
        data: {
          [API_FIELDS.reqAccountForSend]: this.account,
        },
        config: { skipAuthRedirect: true },
        cb: () => {
          this.loading = false;
          this.$message.success('验证码已发送，请查收邮箱');
          if (this.step === 'confirm-email') {
            this.step = 'verify-and-reset';
          }
          this.startCountdown();
        },
        fault: () => {
          this.loading = false;
        },
      });
    },
    startCountdown() {
      this.timeLimit = RESEND_COUNTDOWN;
      this.clearCountdown();
      this.timer = setInterval(() => {
        this.timeLimit -= 1;
        if (this.timeLimit <= 0) {
          this.clearCountdown();
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    onCodeChange(code) {
      this.form.code = code;
    },
    // 提交密码重置
    submitReset() {
      if (!this.$refs.form) return;
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        if (this.form.code.length !== 6) {
          this.$message.error('请输入6位邮箱验证码');
          return;
        }
        if (this.loading) return;
        this.loading = true;
        this.$request({
          url: this.$api.forgetResetPassword,
          type: 'post',
          data: {
            [API_FIELDS.reqAccount]: this.account,
            [API_FIELDS.reqCode]: this.form.code,
            [API_FIELDS.reqNewPassword]: this.form.new_password,
            [API_FIELDS.reqNewPasswordConfirm]: this.form.new_password_confirm,
          },
          config: { skipAuthRedirect: true },
          cb: () => {
            this.loading = false;
            this.$message.success('密码重置成功，请重新登录');
            this.$emit('back-to-login');
          },
          fault: () => {
            this.loading = false;
            // axios 拦截器已经 toast 过后端错误消息，这里不再重复提示
            // 保留在第二步，允许用户修改后再次提交
          },
        });
      });
    },
    backToLogin() {
      this.$emit('back-to-login');
    },
  },
};
